module.exports = __webpack_public_path__ + "images/emoji/older_woman.6134e1cfabe1ee89fa80.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/older_woman.png
// module id = ystB
// module chunks = 2